(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initAnnouncementBar() {
      const bars = document.querySelectorAll('.announcement-bar-section');
      bars.forEach(bar => {
        if (bar.classList.contains('initialized')) return;
        bar.classList.add('initialized');
        
        const slider = bar.querySelector('.announcement-bar__slider');
        const track = bar.querySelector('.announcement-bar__track');
        const slides = bar.querySelectorAll('.announcement-bar__slide');
        const prevBtn = bar.querySelector('.announcement-bar__arrow--prev');
        const nextBtn = bar.querySelector('.announcement-bar__arrow--next');
        
        if (!slider || !track || slides.length <= 1) return;
        
        let currentIndex = 0;
        const speed = parseInt(slider.getAttribute('data-speed')) || 5000;
        let intervalId = null;
        
        function updateSlider() {
          track.style.transform = `translateX(-${currentIndex * 100}%)`;
        }
        
        function nextSlide() {
          currentIndex = (currentIndex + 1) % slides.length;
          updateSlider();
        }
        
        function prevSlide() {
          currentIndex = (currentIndex - 1 + slides.length) % slides.length;
          updateSlider();
        }
        
        function startAutoPlay() {
          if (!intervalId) {
            intervalId = setInterval(nextSlide, speed);
          }
        }
        
        function stopAutoPlay() {
          if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
          }
        }
        
        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            stopAutoPlay();
            prevSlide();
            startAutoPlay();
          });
        }
        
        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            stopAutoPlay();
            nextSlide();
            startAutoPlay();
          });
        }
        
        slider.addEventListener('mouseenter', stopAutoPlay);
        slider.addEventListener('mouseleave', startAutoPlay);
        
        startAutoPlay();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAnnouncementBar);
    } else {
      initAnnouncementBar();
    }

    document.addEventListener('shopify:section:load', initAnnouncementBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const box = document.getElementById('CollectionReadMore');
    const btn = document.getElementById('CollectionReadMoreBtn');
    if (!box || !btn) return;
    const needs = box.scrollHeight > box.clientHeight + 8 || box.textContent.trim().length > 180;
    box.classList.add('is-clamped');
    requestAnimationFrame(() => {
      if (box.scrollHeight > box.clientHeight + 4 || needs) {
        btn.hidden = false;
      }
    });
    btn.addEventListener('click', () => {
      const open = box.classList.toggle('is-clamped') === false;
      btn.textContent = open ? 'Daha az' : 'Devamını oku';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-consent"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const storageKey = 'velora_cookie_consent';
    const consentVal = localStorage.getItem(storageKey);
    
    const consentEl = document.querySelector('.cookie-consent');
    if (!consentEl) return;

    if (consentVal === 'accepted' || consentVal === 'declined') {
      return;
    }

    setTimeout(() => {
      consentEl.classList.add('cookie-consent--show');
      consentEl.setAttribute('aria-hidden', 'false');
    }, 1500);

    const acceptBtn = document.getElementById('CookieAcceptBtn');
    const declineBtn = document.getElementById('CookieDeclineBtn');

    if (acceptBtn) {
      acceptBtn.addEventListener('click', () => {
        localStorage.setItem(storageKey, 'accepted');
        closeConsent();
      });
    }

    if (declineBtn) {
      declineBtn.addEventListener('click', () => {
        localStorage.setItem(storageKey, 'declined');
        closeConsent();
      });
    }

    function closeConsent() {
      consentEl.classList.remove('cookie-consent--show');
      consentEl.classList.add('cookie-consent--hide');
      consentEl.setAttribute('aria-hidden', 'true');
      
      setTimeout(() => {
        consentEl.style.display = 'none';
      }, 500);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function initVeloraHeader() {
    const menuBtn = document.getElementById('MenuToggle');
    const drawer = document.getElementById('MobileNav');
    const searchBtn = document.getElementById('SearchToggle');
    const searchOverlay = document.getElementById('SearchOverlay');
    const searchBackdrop = document.getElementById('SearchBackdrop');
    const closeBtn = document.getElementById('CloseSearch');
    const searchInput = document.getElementById('SearchInput');
    const searchResults = document.getElementById('PredictiveSearchResults');
    const searchIdle = document.getElementById('SearchIdle');
    const searchUrl = searchOverlay && searchOverlay.getAttribute('data-search-url') || '/search';
    let searchCloseTimer;

    const closeMenu = () => {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    };

    const toggleMenu = () => {
      if (!drawer) return;
      const willOpen = !drawer.classList.contains('is-open');
      if (willOpen && searchOverlay && searchOverlay.classList.contains('is-open')) {
        closeSearch();
      }
      drawer.classList.toggle('is-open', willOpen);
      if (menuBtn) menuBtn.setAttribute('aria-expanded', String(willOpen));
    };

    if (menuBtn && drawer) {
      menuBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleMenu();
      });
    }

    const positionSearch = () => {
      if (!searchOverlay) return;
      const header = document.querySelector('.site-header');
      const top = header ? Math.round(header.getBoundingClientRect().bottom) : 72;
      searchOverlay.style.setProperty('--search-top', top + 'px');
    };

    const showIdle = () => {
      if (searchIdle) searchIdle.hidden = false;
      if (searchResults) {
        searchResults.hidden = true;
        searchResults.innerHTML = '';
      }
    };

    const formatPrice = (value) => {
      const n = Number(String(value || '').replace(/[^\d.]/g, ''));
      if (!n) return '';
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        maximumFractionDigits: 0,
      }).format(n);
    };

    const escapeHtml = (value) => String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

    const renderResults = (products, query) => {
      if (!searchResults) return;
      if (searchIdle) searchIdle.hidden = true;
      searchResults.hidden = false;

      const valid = (products || []).filter((p) => p && p.url && p.title && (p.image || p.featured_image) && parseFloat(p.price) > 0).slice(0, 6);
      if (!valid.length) {
        searchResults.innerHTML = `<p class="search-pred__empty">“${escapeHtml(query)}” için sonuç yok.</p>`;
        return;
      }

      const items = valid.map((p) => {
        const image = p.image || p.featured_image || '';
        const type = p.type ? `<span class="search-pred__type">${escapeHtml(p.type)}</span>` : '';
        const price = formatPrice(p.price);
        return `<a href="${escapeHtml(p.url)}" class="search-pred__item">
          <img class="search-pred__thumb" src="${escapeHtml(image)}" alt="${escapeHtml(p.title)}" width="64" height="64" loading="lazy">
          <span>
            ${type}
            <span class="search-pred__title">${escapeHtml(p.title)}</span>
          </span>
          <span class="search-pred__price">${escapeHtml(price)}</span>
        </a>`;
      }).join('');

      searchResults.innerHTML = `${items}<a class="search-pred__all" href="${searchUrl}?q=${encodeURIComponent(query)}&type=product">Tüm sonuçları gör</a>`;
    };

    const openSearch = () => {
      if (!searchOverlay) return;
      closeMenu();
      clearTimeout(searchCloseTimer);
      positionSearch();
      searchOverlay.hidden = false;
      requestAnimationFrame(() => {
        searchOverlay.classList.add('is-open');
        document.documentElement.classList.add('search-open');
        if (searchBtn) searchBtn.setAttribute('aria-expanded', 'true');
      });
      setTimeout(() => searchInput && searchInput.focus(), 80);
    };

    const closeSearch = () => {
      if (!searchOverlay || searchOverlay.hidden) return;
      searchOverlay.classList.remove('is-open');
      document.documentElement.classList.remove('search-open');
      if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
      searchCloseTimer = setTimeout(() => {
        if (!searchOverlay.classList.contains('is-open')) {
          searchOverlay.hidden = true;
          if (searchInput) searchInput.value = '';
          showIdle();
        }
      }, 320);
    };

    if (searchBtn && searchOverlay) {
      searchBtn.addEventListener('click', () => {
        if (searchOverlay.classList.contains('is-open')) closeSearch();
        else openSearch();
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeSearch();
        closeMenu();
      }
    });
    window.addEventListener('resize', () => {
      if (searchOverlay && searchOverlay.classList.contains('is-open')) positionSearch();
    });

    if (searchInput && searchResults) {
      let t;
      searchInput.addEventListener('input', () => {
        const query = searchInput.value.trim();
        clearTimeout(t);
        if (query.length < 2) {
          showIdle();
          return;
        }
        t = setTimeout(() => {
          searchResults.hidden = false;
          if (searchIdle) searchIdle.hidden = true;
          searchResults.innerHTML = '<p class="search-pred__status">Aranıyor…</p>';
          fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`)
            .then((res) => res.json())
            .then((data) => {
              if (searchInput.value.trim() !== query) return;
              renderResults(data?.resources?.results?.products || [], query);
            })
            .catch(() => {
              searchResults.innerHTML = '<p class="search-pred__empty">Arama şu an açılamadı.</p>';
            });
        }, 220);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
